import { io } from "socket.io-client";
import { getBaseUrl } from "./constants";

export const socket = io(getBaseUrl(), { autoConnect: true });
